<template>
  <div class="recruited-user-field">
    <v-input v-model="model" :loading="loading" :placeholder="placeholder" :error="computedError" :disabled="disabled"></v-input>
    <div class="text-color-success" v-if="fetchedUserFioByLogin && !computedError && value && value.length > 0" style="margin-top: .2rem;">{{fetchedUserFioByLogin}}</div>
  </div>
</template>

<script>
import vInput from '@/ui/controls/vInput'

import { UserFioByLoginGQL } from '@/graphql/queries'

let timeOut

export default {
  props: {
    value: {
      type: String,
      default: null
    },

    placeholder: {
      type: String,
      default: null
    },

    disabled: {
      type: Boolean,
      default: false
    },

    error: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      skipQuery: false,
      localError: null,
      fetchedUserFioByLogin: null
    }
  },

  apollo: {
    UserFioByLogin: {
      query: UserFioByLoginGQL,
      variables () {
        return {
          login: this.value
        }
      },

      update: data => data.commonData.UserFioByLogin,

      skip () {
        return !this.value || !this.value.length || this.skipQuery || this.disabled || this.localError
      },

      error ({ gqlError }) {
        if (gqlError.message === 'Unknown') {
          this.localError = 'errors.code.Unknown'
        }
      },

      fetchPolicy: 'network-only'
    }
  },

  components: {
    vInput
  },

  methods: {},

  computed: {
    loading () {
      return this.$apollo.queries.UserFioByLogin.loading
    },

    computedError () {
      return this.localError ? this.$t(this.localError) : this.error
    },

    model: {
      get () {
        return this.value
      },
      set (val) {
        clearTimeout(timeOut)
        this.skipQuery = true
        this.localError = null
        this.fetchedUserFioByLogin = null

        this.$emit('input', val)

        timeOut = setTimeout(() => { this.skipQuery = false }, 300)
      }
    }
  },

  watch: {
    UserFioByLogin (val) {
      this.fetchedUserFioByLogin = val
      this.localError = null
    }
  }
}
</script>
